import { render, staticRenderFns } from "./MEM001P04.vue?vue&type=template&id=16aaee80&"
import script from "./MEM001P04.vue?vue&type=script&lang=js&"
export * from "./MEM001P04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports